// Mensagens locais guardam a chave de tradução (namespace chatbotSuporte); o painel traduz ao exibir.
export const CHAVE_SAUDACAO = "messages.greeting";

// Etapas da pesquisa de satisfação exibida após cada resposta do assistente.
export const ETAPA = {
  RESOLVIDO: "resolvido",
  NOTA: "nota",
  COMENTARIO: "comentario",
  CONCLUIDA: "concluida",
};

// Nota mínima para que uma dúvida resolvida seja considerada atendimento satisfatório.
export const NOTA_SATISFATORIA = 3;

export const estadoInicialPesquisa = {
  etapa: null,
  resolvido: null,
  nota: null,
  comentario: null,
  enviando: false,
};

export const estadoInicialChatbot = {
  iniciada: false,
  conversationId: null,
  messageIds: [],
  messages: [],
  loading: false,
  error: null,
  pesquisa: estadoInicialPesquisa,
};

function gerarIdLocal() {
  return globalThis.crypto?.randomUUID?.() ?? Date.now() + Math.random();
}

export function chatbotConversaReducer(state, action) {
  switch (action.type) {
    case "INICIAR":
      return {
        ...estadoInicialChatbot,
        iniciada: true,
        messages: [{ id: gerarIdLocal(), role: "assistant", chave: CHAVE_SAUDACAO }],
      };
    case "ENVIAR":
      // Uma nova pergunta descarta a pesquisa pendente: ela volta após a próxima resposta.
      return {
        ...state,
        messages: [
          ...state.messages,
          { id: gerarIdLocal(), role: "user", content: action.content },
        ],
        loading: true,
        error: null,
        pesquisa: estadoInicialPesquisa,
      };
    case "SUCESSO":
      return {
        ...state,
        conversationId: action.resposta.conversationId,
        messageIds: action.resposta.messageIds ?? [],
        messages: [
          ...state.messages,
          { id: gerarIdLocal(), role: "assistant", content: action.resposta.content },
        ],
        loading: false,
        pesquisa: { ...estadoInicialPesquisa, etapa: ETAPA.RESOLVIDO },
      };
    case "FALHA":
      // Descarta a pergunta que falhou (a última, adicionada por ENVIAR): o painel
      // devolve o texto ao campo e o reenvio não pode duplicá-la no histórico.
      return {
        ...state,
        messages: state.messages.slice(0, -1),
        loading: false,
        error: action.error,
      };
    case "RESPONDER_RESOLVIDO":
      return {
        ...state,
        pesquisa: { ...state.pesquisa, etapa: ETAPA.NOTA, resolvido: action.resolvido },
      };
    case "RESPONDER_NOTA": {
      const satisfeito = state.pesquisa.resolvido === true && action.nota >= NOTA_SATISFATORIA;
      return {
        ...state,
        pesquisa: {
          ...state.pesquisa,
          etapa: satisfeito ? ETAPA.CONCLUIDA : ETAPA.COMENTARIO,
          nota: action.nota,
        },
      };
    }
    case "COMENTAR":
      return {
        ...state,
        pesquisa: { ...state.pesquisa, etapa: ETAPA.CONCLUIDA, comentario: action.comentario },
      };
    case "FINALIZAR_INICIO":
      return { ...state, error: null, pesquisa: { ...state.pesquisa, enviando: true } };
    case "FINALIZAR_FALHA":
      return { ...state, error: action.error, pesquisa: { ...state.pesquisa, enviando: false } };
    case "NOVA_CONVERSA":
      return estadoInicialChatbot;
    case "RESTAURAR":
      return action.conversa;
    default:
      return state;
  }
}
